import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { OrdersummaryModalPage } from './ordersummary-modal.page';

const routes: Routes = [
  {
    path: '',
    component: OrdersummaryModalPage
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class OrdersummaryModalPageRoutingModule {}
